import { TransitionButton } from 'atoms/TransitionButton';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';
import { AppFooter } from 'templates/AppFooter';
import { AppHeader } from 'templates/AppHeader';
import { Form } from 'templates/Form';
import { PageContent } from 'templates/PageContent';

export function InquirySuccess() {
  const { t: tInquiry } = useTranslationWithLang('inquiry');
  return (
    <>
      <AppHeader />
      <div role="heading" aria-level={1} aria-live="assertive" className="sr-only">
        {tInquiry('TU012_016')}
      </div>
      <PageContent>
        <Form title={tInquiry('TU012_016')}>
          <div className="flex flex-col justify-between items-center h-full gap-8">
            <h1 className="flex justify-center items-center text-xl text-center mt-6">
              {tInquiry('TU012_017')}
            </h1>
            <TransitionButton
              className="w-[9rem]"
              style={{ paddingTop: '0.9rem', paddingBottom: '0.9rem' }}
            />
          </div>
        </Form>
      </PageContent>
      <AppFooter />
    </>
  );
}
